import { Component } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterEvent } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerName } from './core/models/spinners.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  readonly appSpinner: string = SpinnerName.APP
  constructor(private router: Router, private spinner: NgxSpinnerService) {
    router.events.subscribe( (event: RouterEvent) => {
      if( event instanceof RouteConfigLoadStart ){
        spinner.show(this.appSpinner)
      }else if( event instanceof RouteConfigLoadEnd ){
        spinner.hide(this.appSpinner)
      }
    })
  }
}
